import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {}
  }

  @action async GetUserInfoWeb(uid) {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d && d.res
    }
  }


  @action async getRewardList() {
    let res = await http.post('/web/ramadan/gift', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  @action async getCd() {
    let res = await http.post('/web/ramadan/countDown', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 0本 7上
  @action async getRank(daysago) {
    let res = await http.post('/web/ramadan/rank', { daysago })
    if (res && res.code == 0) {
      return res.res
    }
  }
  @action async getTask() {
    let res = await http.post('/web/ramadan/task', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  @action async getReward(taskid) {
    let res = await http.post('/web/ramadan/reward/get', { taskid })
    if (res && res.code == 0) {
      return res.res
    }
  }



  // 拼图部分


  // 任务详细列表
  @action async getJigsawTask() {
    let res = await http.post('/web/pintu/task/info', {})
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 分享
  @action async addJigsawShareCode(code) {
    let res = await http.post('/web/pintu/share/record/add', { code })
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 帮助助力
  @action async jigsawHelp(code) {
    let res = await http.post('/web/pintu/help', { code })
    if (res != 0) {
      return res
    }
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 获取拼图
  @action async getJigsawChip(taskType) {
    let res = await http.post('/web/pintu/fragment/get', { taskType })
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 获取助力用户信息
  @action async getJigsawHelpUser() {
    let res = await http.post('/web/pintu/help/user', {})
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 获取现有拼图
  @action async getJigsawListNow() {
    let res = await http.post('/web/pintu/list', {})
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 解锁拼图
  @action async unLockJigsaw() {
    let res = await http.post('/web/pintu/unlock', {})
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }


  // 碎片
  @action async getChip() {
    let res = await http.post('/web/pintu/user/num', {})
    if (res && res.code == 0) {
      return res.res
    }
  }

  // code
  @action async getCode() {
    let res = await http.post('/web/get/invite/code', {})
    if (res && res.code == 0) {
      return res.res
    }
  }


  // 领取拼图奖励对象
  @action async getJigsawRewardObj() {
    let res = await http.post('/web/pintu/reward/get/info', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 领取拼图奖励
  @action async getJigsawReward(id) {
    let res = await http.post('/web/pintu/reward/get', { id })
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 领取拼图邀请奖励
  @action async gainInviteReward(id) {
    let res = await http.post('/web/pintu/invite/reward/get', { id })
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }
  // 领取拼图邀请奖励
  @action async inviteRewardInfo() {
    let res = await http.post('/web/pintu/invite/reward/get/info')
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }

  @action async jigsawCd() {
    let res = await http.post('/web/pintu/ramadan/countDown')
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }
}


// WEBPACK FOOTER //
// src/store/activity/ramadan.js